module.exports = __webpack_public_path__ + "static/img/exam-1-bg.622f744.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-1-bg.png
// module id = 3FRm
// module chunks = 1